import { AdjustmentMode } from '@app/shared/models/contracts/enums/shared-enums';

export interface BaseCellProps {
  isAmountField: boolean;
}

export interface ReadOnlyCellProps extends BaseCellProps {
  value: number | null | undefined;
  placeholder?: string;
}

export enum CellType {
  EDITABLE = 'editable',
  READ_ONLY = 'read_only',
  EMPTY = 'empty',
}

export enum TableSection {
  AmountAdjustment = 'AmountAdjustment',
  SharesAdjustment = 'SharesAdjustment',
  AmountClosingBalance = 'AmountClosingBalance',
  SharesClosingBalance = 'SharesClosingBalance',
  RealBuybackValue = 'RealBuybackValue',
}

export interface InputModeState {
  hasAdjustmentInput: boolean;
  hasClosingInput: boolean;
  amountMode: AdjustmentMode | null;
  sharesMode: AdjustmentMode | null;
}
